import { render } from "./request-password-forget.vue?vue&type=template&id=086a7c78&ts=true"
import script from "./request-password-forget.vue?vue&type=script&lang=ts"
export * from "./request-password-forget.vue?vue&type=script&lang=ts"

import exportComponent from "/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__